import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Offer } from 'prismic';
import { ProductListItem } from 'product-shared';
import { CurrencyFormatterPipe } from 'utils';

@Component({
  selector: 'lib-offer-box-price',
  templateUrl: './offer-box-price.component.html',
  styleUrls: ['./offer-box-price.component.scss'],
  imports: [CurrencyFormatterPipe, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferBoxPriceComponent {
  @Input() offer: Offer<ProductListItem>;
  @Input() priceFontSize: string;
}
